import { render, staticRenderFns } from "./AddStoreCouponComponent.vue?vue&type=template&id=0fa677ff&scoped=true"
import script from "./AddStoreCouponComponent.vue?vue&type=script&lang=js"
export * from "./AddStoreCouponComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa677ff",
  null
  
)

export default component.exports